import {
  MSG_SERVICE,
  MSG_ORDER_NG,
  MSG_CART,
  MSG_ORDER,
} from "../constants/messages";

export const isOrderDisabledItem = function (menu) {
  // 売切 or 公開以外
  return menu.stock == 0 || !menu.publish;
}

export const hasContainsSoldOutItems = function (menus) {
  return menus.some((menu) => isOrderDisabledItem(menu));
}

/**
 * 共通チェック
 */
export const CHECK_TYPE = {
  SERVICE_ACTIVE: 1, // サービス稼働中かどうか
  USER_STATUS_IN_CONFIRM: 20, // ユーザ 注文状態「注文確認中」かどうか
  USER_VISIT_TIME: 21, // ユーザ 来店時刻が正当かどうか
  SHOP_STATUS_SUSPENDED: 30, // 店舗 注文状態「一時停止中」かどうか
  SHOP_STATUS_NOT_ACCEPTED: 31, // 店舗 注文状態「停止中」かどうか
  ORDER_TIME_IN_RANGE: 40, // 注文の最短受取日時が提供可能範囲内かどうか
  ORDER_AVAILABLE: 41, // 注文が有効かどうか
  MST_MENU_CHANGED: 50, // カート内メニュー「マスターと差分がある」かどうか
  MST_MENU_DELETED: 51, // カート内メニュー「マスターが削除されている」かどうか
  MST_MENU_SOLDOUT: 52, // カート内メニュー「マスターが売切れている」かどうか
};

/**
 * 共通チェック エラーMSG
 * @param {*} checkType 
 * @returns 
 */
export const createCheckErrMsg = (checkType) => {
  switch (checkType) {
    case CHECK_TYPE.SERVICE_ACTIVE:
      return MSG_SERVICE.IN_MAINTENANCE;
    //
    case CHECK_TYPE.USER_STATUS_IN_CONFIRM:
      return MSG_ORDER_NG.IN_CONFIRM;
    case CHECK_TYPE.USER_VISIT_TIME:
      return MSG_ORDER.VISIT_TIME;
    //
    case CHECK_TYPE.SHOP_STATUS_SUSPENDED:
      return MSG_ORDER_NG.SUSPENDED;
    case CHECK_TYPE.SHOP_STATUS_NOT_ACCEPTED:
      return MSG_ORDER_NG.NOT_ACCEPTED;
    //
    case CHECK_TYPE.ORDER_AVAILABLE:
      return MSG_ORDER.INVALID;
    case CHECK_TYPE.ORDER_TIME_IN_RANGE:
      return MSG_ORDER_NG.NOT_ACCEPTED;
    //
    case CHECK_TYPE.MST_MENU_CHANGED:
    case CHECK_TYPE.MST_MENU_DELETED:
      return MSG_CART.CHANGED;
    case CHECK_TYPE.MST_MENU_SOLDOUT:
      return MSG_ORDER.INVALID;
    default:
      throw Error(`not implemented: ${checkType}`);
  }
};

/**
 * カート内アイテム
 */
export const CART_ITEM = {
  OK: 0,
  // 表示値をそのままチェック
  SOLDOUT: 1,
  NOT_PUBLISH: 2,
  // 最新値取得後にチェック
  UPDATED: 3,
  DELETED: 4,
};
